var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "950" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c(
                "v-flex",
                { attrs: { xs9: "" } },
                [
                  _c("v-icon", [_vm._v("done")]),
                  _vm._v("Finalizar programación")
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                }
              },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _vm.listado_funcionarios.length == 0 &&
                      _vm.bandera_activa_finalizacion
                        ? _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      name: "input-7-4",
                                      label: "Hoja de ruta",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.form.comprobante,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "comprobante", $$v)
                                      },
                                      expression: "form.comprobante"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.listado_funcionarios.length == 0 &&
                      _vm.bandera_activa_finalizacion == true
                        ? _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md12: "" } },
                                [
                                  _c("v-icon", [
                                    _vm._v(
                                      _vm._s(
                                        this.file == "" ? "file_upload" : "done"
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      class:
                                        this.file == ""
                                          ? "archivo_vacio"
                                          : "archivo_cargado"
                                    },
                                    [
                                      _c("v-icon", [
                                        _vm._v(
                                          _vm._s(
                                            this.file == ""
                                              ? "file_upload"
                                              : "done"
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("input", {
                                        ref: "file",
                                        staticClass: "input-file",
                                        attrs: {
                                          type: "file",
                                          accept: "application/pdf",
                                          rules: _vm.$validate(["required"]),
                                          required: "",
                                          outline: "",
                                          clearable: ""
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.handleFileUpload()
                                          }
                                        }
                                      }),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            this.file == ""
                                              ? "Adjuntar documento de respaldo"
                                              : this.file.name
                                          ) +
                                          "\n              "
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.file
                                    ? _c(
                                        "p",
                                        { staticClass: "red--text body-1" },
                                        [
                                          _vm._v(
                                            "\n                *Debe seleccionar un archivo\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.errors.denied
                                    ? _c(
                                        "p",
                                        { staticClass: "red--text body-1" },
                                        [
                                          _vm._v(
                                            "\n                *Formato no admitido por el sistema\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.listado_funcionarios.length > 0 &&
                      _vm.bandera_activa_finalizacion == false
                        ? _c(
                            "v-layout",
                            [
                              _c("v-flex", { attrs: { xs9: "" } }, [
                                _c("h4", [
                                  _c("strong", [
                                    _vm._v(
                                      "Listado de servidores publicos que no cuentan con sus\n                  programaciones aprobadas o tienen alguna observación"
                                    )
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs3: "" } },
                                [
                                  _c(
                                    "v-menu",
                                    {
                                      attrs: {
                                        "open-on-hover": "",
                                        buttom: ""
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(ref) {
                                              var on = ref.on
                                              return [
                                                _c("v-icon", _vm._g({}, on), [
                                                  _vm._v("help_outline")
                                                ])
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        912173184
                                      )
                                    },
                                    [
                                      _vm._v(" "),
                                      _c(
                                        "v-card",
                                        [
                                          _c(
                                            "v-card-text",
                                            { staticClass: "ayuda" },
                                            [
                                              _c(
                                                "v-layout",
                                                [
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      staticClass:
                                                        "text-xs-center caption"
                                                    },
                                                    [
                                                      _c("strong", [
                                                        _c(
                                                          "p",
                                                          [
                                                            _c("v-icon", [
                                                              _vm._v(
                                                                "help_outline"
                                                              )
                                                            ])
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c("p", [
                                                          _vm._v(
                                                            "Solo puede aprobar las programaciones cuando"
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("p", [
                                                          _vm._v(
                                                            "todos los servidores públicos del listado"
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("p", [
                                                          _vm._v(
                                                            "tengan sus programaciones aprobadas por sus"
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("p", [
                                                          _vm._v(
                                                            "\n                            respectivos jefes y no se encuentren rechazados\n                            por los mismos\n                          "
                                                          )
                                                        ])
                                                      ])
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.listado_funcionarios.length == 0 &&
                      _vm.bandera_activa_finalizacion
                        ? _c(
                            "v-layout",
                            [
                              _c("v-card", { attrs: { color: "#DFFF89" } }, [
                                _c("h4", [
                                  _c("strong", [
                                    _vm._v(
                                      "Todos los servidores enviaron su programación de vacaciones\n                  y se encuentran sin observaciones"
                                    )
                                  ])
                                ])
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.listado_funcionarios.length > 0 &&
                      _vm.bandera_activa_finalizacion == false
                        ? _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-data-table", {
                                    staticClass: "elevation-1",
                                    attrs: {
                                      items: _vm.listado_funcionarios,
                                      "hide-actions": "",
                                      headers: _vm.headers
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "items",
                                          fn: function(props) {
                                            return [
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(props.item.nombre)
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(props.item.unidad)
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _c(
                                                    "v-chip",
                                                    {
                                                      attrs: {
                                                        dark: "",
                                                        color:
                                                          props.item
                                                            .id_estado == 22
                                                            ? "#9637FF"
                                                            : props.item
                                                                .id_estado == 51
                                                            ? "#00DB15"
                                                            : props.item
                                                                .id_estado == 73
                                                            ? "#7ee06a"
                                                            : props.item
                                                                .id_estado == 66
                                                            ? "#73b6c4"
                                                            : props.item
                                                                .id_estado == 72
                                                            ? "#9d20b6"
                                                            : props.item
                                                                .id_estado == 70
                                                            ? "#c267a5"
                                                            : props.item
                                                                .id_estado == 47
                                                            ? "#9aed65"
                                                            : props.item
                                                                .id_estado == 68
                                                            ? "#6f9eb8"
                                                            : props.item
                                                                .id_estado == 67
                                                            ? "#83e0e3"
                                                            : props.item
                                                                .id_estado == 66
                                                            ? "#b0bed6"
                                                            : props.item
                                                                .id_estado == 65
                                                            ? "#c267be"
                                                            : props.item
                                                                .id_estado == 54
                                                            ? "#8f66b8"
                                                            : props.item
                                                                .id_estado == 58
                                                            ? "#88a7f5"
                                                            : props.item
                                                                .id_estado == 57
                                                            ? "#7c73c3"
                                                            : props.item
                                                                .id_estado == 56
                                                            ? "#64a054"
                                                            : props.item
                                                                .id_estado == 55
                                                            ? "#19afb4"
                                                            : "#FF3400"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            props.item.estado
                                                          ) +
                                                          "\n                    "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      815077122
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "error", loading: _vm.loading },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.close()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("close")]),
                      _vm._v("\n          Cancelar\n        ")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        disabled:
                          !this.bandera_aprobacion || !_vm.form.comprobante
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.finalizarProgramacion()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("done")]),
                      _vm._v("\n          Finalizar\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f2a3e0c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2a3e0c0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacacion_rrhh/dialogs/FinalizarProgramacionesDelMinisterio.vue
// module id = null
// module chunks = 